import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asBannerInsteadVideo_wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "asBannerInsteadVideo_play" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "asBannerInsteadVideo_blockTimer"
}
const _hoisted_5 = { class: "asBannerInsteadVideo_timer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "asBannerInsteadVideo_timerSpacer" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "asBannerInsteadVideo_continue_icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_banner = _resolveComponent("as-banner")!

  return (_ctx.isShowBanner)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "asBannerInsteadVideo",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlerClick && _ctx.handlerClick(...args)))
      }, [
        (_ctx.firstPlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true),
        _createVNode(_component_as_banner, {
          banner: _ctx.banner,
          platform: _ctx.platform,
          position: _ctx.position,
          placement: _ctx.placement,
          class: _normalizeClass(`asBannerInsteadVideo_banner -${_ctx.placement} -${_ctx.platform}${_ctx.placement}`)
        }, null, 8, ["banner", "platform", "position", "placement", "class"]),
        (!_ctx.firstPlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('LeftSeconds')) + ": " + _toDisplayString(_ctx.formattedTime), 1),
              (_ctx.showSkipBtn)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_6,
                    _createElementVNode("div", {
                      class: "asBannerInsteadVideo_continue",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handlerContinue && _ctx.handlerContinue(...args)), ["prevent","stop"]))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Skip')) + " ", 1),
                      _hoisted_7
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}